/* ==========================================================================
   MANGOAL — The Quiet Black Friday 2026
   Vanilla JS. No dependencies. All interaction is progressive enhancement.
   ========================================================================== */

(function () {
  "use strict";

  var root = document.querySelector("[data-bf-page]");
  if (!root) return;

  var $ = function (sel, ctx) {
    return (ctx || root).querySelector(sel);
  };
  var $$ = function (sel, ctx) {
    return Array.prototype.slice.call((ctx || root).querySelectorAll(sel));
  };

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var finePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  var isShopify = !!window.BF26_SHOPIFY;
  var config = Object.assign(
    {
      memberDeadline: "2026-11-24T21:00:00-05:00",
      saleEnd: "2026-12-01T04:59:00Z",
    },
    window.BF26_CONFIG || {}
  );

  var FALLBACK_PRODUCTS = [
    {
      key: "front",
      name: "The Front Runner",
      variant: "4K front",
      price: 169,
      compare: 239,
      image: null,
      variantId: null,
    },
    {
      key: "full",
      name: "The Full Picture",
      variant: "4K front + 1080p rear",
      price: 229,
      compare: 329,
      image: null,
      variantId: null,
    },
    {
      key: "night",
      name: "The Night Watch",
      variant: "4K front + rear + parking harness",
      price: 289,
      compare: 419,
      image: null,
      variantId: null,
    },
  ];

  var PRODUCTS = Array.isArray(window.BF26_PRODUCTS) && window.BF26_PRODUCTS.length
    ? window.BF26_PRODUCTS
    : FALLBACK_PRODUCTS;

  var productByKey = {};
  PRODUCTS.forEach(function (product) {
    if (product && product.key) productByKey[product.key] = product;
  });

  var freeShippingThreshold = 199;
  var cartReady = false;

  /* ------------------------------------------------------------------------
     Utilities
     ------------------------------------------------------------------------ */

  function pad(value) {
    return String(Math.max(0, value)).padStart(2, "0");
  }

  function money(value) {
    var number = Number(value) || 0;
    var hasCents = Math.round(number * 100) % 100 !== 0;
    return (
      "$" +
      number.toLocaleString("en-US", {
        minimumFractionDigits: hasCents ? 2 : 0,
        maximumFractionDigits: 2,
      })
    );
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function safeImageUrl(value) {
    var url = String(value || "");
    if (/^(https?:)?\/\//.test(url) || /^\/[^/]/.test(url)) return escapeHtml(url);
    return "";
  }

  function readStore(key, fallback) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function writeStore(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      return false;
    }
  }

  function removeStore(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      /* no-op */
    }
  }

  var toastTimer = null;
  function showToast(message) {
    var toast = $("[data-toast]");
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add("is-visible");
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      toast.classList.remove("is-visible");
    }, 3000);
  }

  /* ------------------------------------------------------------------------
     Header + progress + hero motion
     ------------------------------------------------------------------------ */

  var header = $("[data-header]");
  var progress = $("[data-progress]");
  var hero = $(".bf-hero");
  var glow = $("[data-glow]");
  var mobileCta = $("[data-mobile-cta]");
  var accessSection = $("#access");
  var footer = $(".bf-footer");
  var accessVisible = false;
  var footerVisible = false;
  var scrollQueued = false;
  var glowX = 0;
  var glowY = 0;
  var glowQueued = false;

  function updateOnScroll() {
    var scrollTop = window.scrollY || window.pageYOffset;
    var height = document.documentElement.scrollHeight - window.innerHeight;

    if (header) {
      header.classList.toggle("is-stuck", scrollTop > 14);
    }

    if (progress) {
      var ratio = height > 0 ? Math.min(1, Math.max(0, scrollTop / height)) : 0;
      progress.style.transform = "scaleX(" + ratio + ")";
    }

    if (mobileCta) {
      var show = scrollTop > window.innerHeight * 0.72 && !accessVisible && !footerVisible;
      mobileCta.classList.toggle("is-visible", show);
    }

    scrollQueued = false;
  }

  function onScroll() {
    if (scrollQueued) return;
    scrollQueued = true;
    window.requestAnimationFrame(updateOnScroll);
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  updateOnScroll();

  if (glow && finePointer && !reduceMotion && hero) {
    hero.addEventListener(
      "pointermove",
      function (event) {
        var rect = hero.getBoundingClientRect();
        glowX = event.clientX - rect.left;
        glowY = event.clientY - rect.top;
        glow.style.opacity = "1";
        if (glowQueued) return;
        glowQueued = true;
        window.requestAnimationFrame(function () {
          glow.style.transform = "translate3d(" + (glowX - 320) + "px," + (glowY - 320) + "px,0)";
          glowQueued = false;
        });
      },
      { passive: true }
    );

    hero.addEventListener("pointerleave", function () {
      glow.style.opacity = "0";
    });
  }

  /* ------------------------------------------------------------------------
     Countdown
     ------------------------------------------------------------------------ */

  var countdowns = $$("[data-countdown]");

  function updateCountdowns() {
    var now = Date.now();

    countdowns.forEach(function (el) {
      var deadline = el.getAttribute("data-deadline");
      if (!deadline) {
        deadline = el.getAttribute("data-countdown") === "member" ? config.memberDeadline : config.saleEnd;
      }

      var end = new Date(deadline).getTime();
      var dayEl = $("[data-days]", el);
      var hourEl = $("[data-hours]", el);
      var minEl = $("[data-mins]", el);
      var secEl = $("[data-secs]", el);

      if (!Number.isFinite(end)) {
        if (dayEl) dayEl.textContent = "00";
        if (hourEl) hourEl.textContent = "00";
        if (minEl) minEl.textContent = "00";
        if (secEl) secEl.textContent = "00";
        return;
      }

      var diff = Math.max(0, end - now);
      var seconds = Math.floor(diff / 1000);
      var days = Math.floor(seconds / 86400);
      var hours = Math.floor((seconds % 86400) / 3600);
      var mins = Math.floor((seconds % 3600) / 60);
      var secs = seconds % 60;

      if (dayEl) dayEl.textContent = pad(days);
      if (hourEl) hourEl.textContent = pad(hours);
      if (minEl) minEl.textContent = pad(mins);
      if (secEl) secEl.textContent = pad(secs);
    });
  }

  if (countdowns.length) {
    updateCountdowns();
    window.setInterval(updateCountdowns, 1000);
  }

  /* ------------------------------------------------------------------------
     Reveals + stat counters
     ------------------------------------------------------------------------ */

  var revealItems = $$(".bf-reveal");
  var countItems = $$("[data-count]");

  function animateCount(el) {
    if (el.dataset.counted === "true") return;
    el.dataset.counted = "true";
    var target = Number(el.getAttribute("data-count"));
    var suffix = el.getAttribute("data-suffix") || "";
    if (!Number.isFinite(target)) return;

    if (reduceMotion) {
      el.textContent = target + suffix;
      return;
    }

    var start = performance.now();
    var duration = 1150;

    function frame(now) {
      var progressValue = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - progressValue, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (progressValue < 1) window.requestAnimationFrame(frame);
    }

    window.requestAnimationFrame(frame);
  }

  if ("IntersectionObserver" in window) {
    var revealObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-in");
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
    );

    revealItems.forEach(function (item) {
      revealObserver.observe(item);
    });

    var countObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animateCount(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    countItems.forEach(function (item) {
      countObserver.observe(item);
    });

    if (accessSection) {
      var accessObserver = new IntersectionObserver(
        function (entries) {
          accessVisible = entries[0].isIntersecting;
          onScroll();
        },
        { threshold: 0.08 }
      );
      accessObserver.observe(accessSection);
    }

    if (footer) {
      var footerObserver = new IntersectionObserver(
        function (entries) {
          footerVisible = entries[0].isIntersecting;
          onScroll();
        },
        { threshold: 0.05 }
      );
      footerObserver.observe(footer);
    }
  } else {
    revealItems.forEach(function (item) {
      item.classList.add("is-in");
    });
    countItems.forEach(animateCount);
  }

  /* ------------------------------------------------------------------------
     Product drop stage
     ------------------------------------------------------------------------ */

  var stage = $("[data-stage]");
  var kits = $$(".bf-kit");
  var stageSlides = stage ? $$("[data-slide]", stage) : [];

  function setKit(index) {
    if (!stage || !kits.length) return;
    var safeIndex = Math.max(0, Math.min(kits.length - 1, Number(index) || 0));
    var kit = kits[safeIndex];

    stage.setAttribute("data-kit", String(safeIndex));

    var view = $("[data-stage-view]");
    var sensor = $("[data-stage-sensor]");
    var included = $("[data-stage-included]");
    var serial = $("[data-stage-serial]");

    if (view) view.textContent = kit.getAttribute("data-view") || "";
    if (sensor) sensor.textContent = kit.getAttribute("data-sensor") || "";
    if (included) included.textContent = kit.getAttribute("data-included") || "";
    if (serial) serial.textContent = pad(safeIndex + 1);

    kits.forEach(function (item, itemIndex) {
      var active = itemIndex === safeIndex;
      item.classList.toggle("is-active", active);
      var select = $("[data-select-kit]", item);
      if (select) select.setAttribute("aria-pressed", active ? "true" : "false");
    });

    stageSlides.forEach(function (slide, slideIndex) {
      slide.classList.toggle("is-active", slideIndex === safeIndex);
    });
  }

  kits.forEach(function (kit, index) {
    var select = $("[data-select-kit]", kit);
    if (!select) return;

    select.addEventListener("click", function () {
      setKit(index);
    });

    if (finePointer) {
      kit.addEventListener("mouseenter", function () {
        setKit(index);
      });
    }

    select.addEventListener("focus", function () {
      setKit(index);
    });
  });

  if (kits.length) setKit(0);

  /* ------------------------------------------------------------------------
     Member pass
     ------------------------------------------------------------------------ */

  var passcard = $("[data-passcard]");
  var memberForm = $("[data-member-form]") || $("form.bf-member-form");
  var memberSuccess = $("[data-member-success]");
  var memberError = $("[data-member-error]");
  var memberSubmit = $("[data-member-submit]");
  var memberNameInput = $("#bf-member-name");
  var memberEmailInput = $("#bf-member-email");
  var memberStorageKey = "mangoal-bf26-member";
  var memberState = readStore(memberStorageKey, null);

  function makePassId(email) {
    var hash = 0;
    var value = String(email || "bf26");
    for (var i = 0; i < value.length; i += 1) {
      hash = (hash << 5) - hash + value.charCodeAt(i);
      hash |= 0;
    }
    var code = Math.abs(hash).toString(36).toUpperCase().slice(-4);
    return "BF26-" + code.padStart(4, "0");
  }

  function setMemberState(state, options) {
    if (!passcard) return;
    var opts = options || {};
    memberState = state;
    writeStore(memberStorageKey, state);

    $$("[data-member-name]").forEach(function (el) {
      el.textContent = state.name || "Member";
    });
    $$("[data-card-name]").forEach(function (el) {
      el.textContent = (state.name || "Member").toUpperCase();
    });
    $$("[data-pass-no]").forEach(function (el) {
      el.textContent = state.pass || "BF26-0000";
    });

    passcard.classList.add("is-member");

    if (memberForm) memberForm.hidden = true;
    if (memberSuccess) memberSuccess.hidden = false;

    if (opts.animate && passcard.animate) {
      passcard.animate(
        [
          { transform: "scale(1)" },
          { transform: "scale(1.015)" },
          { transform: "scale(1)" },
        ],
        { duration: 500, easing: "cubic-bezier(.2,.7,.2,1)" }
      );
    }

    updateCalendarLink(state);
    if (cartReady) renderCart();
  }

  function clearMemberState() {
    memberState = null;
    removeStore(memberStorageKey);
    if (passcard) passcard.classList.remove("is-member");
    if (memberForm) memberForm.hidden = false;
    if (memberSuccess) memberSuccess.hidden = true;
    if (memberNameInput) {
      memberNameInput.value = "";
      memberNameInput.removeAttribute("aria-invalid");
    }
    if (memberEmailInput) {
      memberEmailInput.value = "";
      memberEmailInput.removeAttribute("aria-invalid");
    }
    if (memberError) {
      memberError.hidden = true;
      memberError.textContent = "";
    }
    $$("[data-pass-no]").forEach(function (el) {
      el.textContent = "BF26-0000";
    });
    $$("[data-card-name]").forEach(function (el) {
      el.textContent = "YOUR NAME";
    });
    if (cartReady) renderCart();
    if (memberNameInput) memberNameInput.focus();
  }

  function updateCalendarLink(state) {
    var link = $("[data-ics]");
    if (!link) return;

    function icsDate(date) {
      return date.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
    }

    var startDate = new Date(config.memberDeadline);
    if (Number.isNaN(startDate.getTime())) startDate = new Date("2026-11-25T02:00:00Z");
    var endDate = new Date(startDate.getTime() + 60 * 60 * 1000);

    var ics = [
      "BEGIN:VCALENDAR",
      "VERSION:2.0",
      "PRODID:-//MANGOAL//Black Friday 2026//EN",
      "CALSCALE:GREGORIAN",
      "BEGIN:VEVENT",
      "UID:" + (state.pass || "bf26") + "@mangoal.com",
      "DTSTAMP:" + icsDate(new Date()),
      "DTSTART:" + icsDate(startDate),
      "DTEND:" + icsDate(endDate),
      "SUMMARY:MANGOAL Black Friday — Member Access",
      "DESCRIPTION:Your 48-hour early access to The Quiet Black Friday opens now. Shop at mangoal.com.",
      "LOCATION:mangoal.com",
      "END:VEVENT",
      "END:VCALENDAR",
    ].join("\r\n");

    try {
      var blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
      var url = URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute("download", "mangoal-bf26-member.ics");
    } catch (error) {
      link.href = "#access";
      link.removeAttribute("download");
    }
  }

  function validateMember(name, email) {
    if (!name || name.length < 2) return { field: memberNameInput, message: "Add your first name so we can put it on the pass." };
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      return { field: memberEmailInput, message: "That email doesn't look right. Check it and try again." };
    }
    return null;
  }

  var memberPosted =
    /[?&]customer_posted=true/.test(window.location.search) ||
    !!$("[data-member-joined]");

  if (memberPosted) {
    setMemberState(
      {
        name: readStore("mangoal-bf26-name", "MEMBER") || "MEMBER",
        email: "shopify-customer",
        pass: "BF26-MEMBER",
        joinedAt: new Date().toISOString(),
      },
      {}
    );
  } else if (memberState && memberState.email) {
    setMemberState(memberState);
  }

  if (memberForm) {
    memberForm.addEventListener("submit", function (event) {
      if (memberForm.hasAttribute("data-native-form")) return;
      if (isShopify && memberForm.querySelector('input[name="form_type"]')) {
        writeStore("mangoal-bf26-name", memberNameInput ? memberNameInput.value.trim() : "");
        return;
      }
      event.preventDefault();

      var name = memberNameInput ? memberNameInput.value.trim() : "";
      var email = memberEmailInput ? memberEmailInput.value.trim() : "";
      var problem = validateMember(name, email);

      if (memberNameInput) memberNameInput.removeAttribute("aria-invalid");
      if (memberEmailInput) memberEmailInput.removeAttribute("aria-invalid");

      if (problem) {
        if (memberError) {
          memberError.textContent = problem.message;
          memberError.hidden = false;
        }
        if (problem.field) {
          problem.field.setAttribute("aria-invalid", "true");
          problem.field.focus();
        }
        return;
      }

      if (memberError) {
        memberError.hidden = true;
        memberError.textContent = "";
      }

      var original = memberSubmit ? memberSubmit.innerHTML : "";
      if (memberSubmit) {
        memberSubmit.disabled = true;
        memberSubmit.textContent = "Securing your pass…";
      }

      window.setTimeout(function () {
        if (memberSubmit) {
          memberSubmit.disabled = false;
          memberSubmit.innerHTML = original;
        }
        setMemberState(
          {
            name: name,
            email: email,
            pass: makePassId(email),
            joinedAt: new Date().toISOString(),
          },
          { animate: true }
        );
        showToast("Your member pass is reserved for 11.24.");
      }, 420);
    });
  }

  [memberNameInput, memberEmailInput].forEach(function (input) {
    if (!input) return;
    input.addEventListener("input", function () {
      input.removeAttribute("aria-invalid");
      if (memberError) {
        memberError.hidden = true;
        memberError.textContent = "";
      }
    });
  });

  var memberReset = $("[data-member-reset]");
  if (memberReset) {
    memberReset.addEventListener("click", function () {
      clearMemberState();
    });
  }

  var copyPass = $("[data-copy-pass]");
  if (copyPass) {
    copyPass.addEventListener("click", function () {
      var pass = memberState && memberState.pass ? memberState.pass : "BF26-0000";
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(pass).then(
          function () {
            showToast("Pass ID " + pass + " copied.");
          },
          function () {
            showToast("Your pass ID is " + pass + ".");
          }
        );
      } else {
        showToast("Your pass ID is " + pass + ".");
      }
    });
  }

  if (passcard && finePointer && !reduceMotion) {
    var tiltFrame = null;
    var tiltX = 0;
    var tiltY = 0;

    passcard.addEventListener(
      "pointermove",
      function (event) {
        var rect = passcard.getBoundingClientRect();
        tiltX = ((event.clientY - rect.top) / rect.height - 0.5) * -5;
        tiltY = ((event.clientX - rect.left) / rect.width - 0.5) * 6;
        if (tiltFrame) return;
        tiltFrame = window.requestAnimationFrame(function () {
          passcard.style.transform = "rotateX(" + tiltX.toFixed(2) + "deg) rotateY(" + tiltY.toFixed(2) + "deg)";
          tiltFrame = null;
        });
      },
      { passive: true }
    );

    passcard.addEventListener("pointerleave", function () {
      passcard.style.transform = "rotateX(0deg) rotateY(0deg)";
    });
  }

  /* ------------------------------------------------------------------------
     Fitment
     ------------------------------------------------------------------------ */

  var FITMENT = window.BF26_FITMENT || {
    BMW: {
      "X3 (G01)": { from: 2018, kit: "full" },
      "X5 (G05)": { from: 2019, kit: "night" },
      "3 Series (G20)": { from: 2019, kit: "full" },
      "M4 (G82)": { from: 2021, kit: "front" },
    },
    Ford: {
      "F-150": { from: 2018, kit: "night" },
      Explorer: { from: 2020, kit: "full" },
      Mustang: { from: 2015, kit: "full" },
      Escape: { from: 2020, kit: "front" },
    },
    Toyota: {
      Camry: { from: 2018, kit: "full" },
      RAV4: { from: 2019, kit: "full" },
      Sienna: { from: 2021, kit: "night" },
      "bZ4X": { from: 2023, kit: "front" },
    },
    Tesla: {
      "Model 3": { from: 2017, kit: "front" },
      "Model Y": { from: 2020, kit: "front" },
    },
    "Mercedes-Benz": {
      "C-Class (W206)": { from: 2022, kit: "full" },
      "GLC (X254)": { from: 2023, kit: "full" },
      "AMG GT": { from: 2015, kit: "front" },
    },
    Audi: {
      "A4 (B9)": { from: 2017, kit: "full" },
      "Q5 (FY)": { from: 2018, kit: "full" },
      "e-tron": { from: 2019, kit: "night" },
    },
    Porsche: {
      Panamera: { from: 2017, kit: "night" },
      Macan: { from: 2019, kit: "full" },
      "911 (992)": { from: 2020, kit: "front" },
    },
    Chevrolet: {
      "Silverado 1500": { from: 2019, kit: "night" },
      Camaro: { from: 2016, kit: "front" },
      Equinox: { from: 2018, kit: "full" },
    },
    RAM: {
      "1500": { from: 2019, kit: "night" },
      "2500": { from: 2019, kit: "night" },
    },
    Volvo: {
      XC90: { from: 2016, kit: "night" },
      XC60: { from: 2018, kit: "full" },
    },
  };

  if (Array.isArray(window.BF26_FITMENT)) {
    var normalizedFitment = {};
    window.BF26_FITMENT.forEach(function (vehicle) {
      if (!vehicle || !vehicle.make || !vehicle.model) return;
      if (!normalizedFitment[vehicle.make]) normalizedFitment[vehicle.make] = {};
      normalizedFitment[vehicle.make][vehicle.model] = {
        from: Number(vehicle.from) || 2015,
        kit: vehicle.kit,
      };
    });
    FITMENT = normalizedFitment;
  }

  var fitMake = $("[data-fit-make]");
  var fitModel = $("[data-fit-model]");
  var fitYear = $("[data-fit-year]");
  var fitForm = $("[data-fit-form]");
  var fitResult = $("[data-fit-result]");
  var fitAdd = $("[data-fit-add]");
  var MAX_YEAR = Number(config.maxYear) || 2026;

  function fillSelect(select, values, placeholder) {
    if (!select) return;
    var fragment = document.createDocumentFragment();
    var first = document.createElement("option");
    first.value = "";
    first.textContent = placeholder;
    fragment.appendChild(first);

    values.forEach(function (value) {
      var option = document.createElement("option");
      option.value = value;
      option.textContent = value;
      fragment.appendChild(option);
    });

    select.innerHTML = "";
    select.appendChild(fragment);
  }

  function resetFitResult() {
    if (!fitResult) return;
    fitResult.classList.remove("is-ready");
    if (fitAdd) fitAdd.setAttribute("data-add-key", "full");
  }

  function populateModels(make) {
    if (!fitMake || !fitModel || !fitYear) return;
    var models = FITMENT[make] || null;
    if (!models) {
      fillSelect(fitModel, [], "Select model");
      fillSelect(fitYear, [], "Select year");
      fitModel.disabled = true;
      fitYear.disabled = true;
      resetFitResult();
      return;
    }

    fillSelect(fitModel, Object.keys(models).sort(), "Select model");
    fillSelect(fitYear, [], "Select year");
    fitModel.disabled = false;
    fitYear.disabled = true;
    resetFitResult();
  }

  function populateYears(make, model) {
    if (!fitYear) return;
    var entry = FITMENT[make] && FITMENT[make][model];
    if (!entry) {
      fillSelect(fitYear, [], "Select year");
      fitYear.disabled = true;
      resetFitResult();
      return;
    }

    var years = [];
    for (var year = MAX_YEAR; year >= entry.from; year -= 1) {
      years.push(String(year));
    }
    fillSelect(fitYear, years, "Select year");
    fitYear.disabled = false;
    resetFitResult();
  }

  function showFit(make, model, year) {
    if (!make || !model || !year) return;
    var entry = FITMENT[make] && FITMENT[make][model];
    if (!entry || !fitResult) return;

    var product = productByKey[entry.kit] || PRODUCTS[0];
    var vehicle = year + " " + make + " " + model;

    $$("[data-fit-vehicle]", fitResult).forEach(function (el) {
      el.textContent = vehicle;
    });
    $$("[data-fit-kit]", fitResult).forEach(function (el) {
      el.textContent = product ? product.name : "The Full Picture";
    });
    $$("[data-fit-kit-desc]", fitResult).forEach(function (el) {
      el.textContent = product
        ? product.variant + ". Pre-routed for your vehicle."
        : "Pre-routed for your vehicle.";
    });
    $$("[data-fit-price]", fitResult).forEach(function (el) {
      el.textContent = product ? money(product.price) : "$229";
    });
    $$("[data-fit-compare]", fitResult).forEach(function (el) {
      el.textContent = product && product.compare ? money(product.compare) : "";
      el.hidden = !(product && product.compare);
    });

    if (fitAdd) {
      fitAdd.setAttribute("data-add-key", product ? product.key : "full");
      fitAdd.setAttribute("aria-label", "Add " + (product ? product.name : "kit") + " to bag");
    }

    fitResult.classList.add("is-ready");
  }

  if (fitMake) {
    fillSelect(fitMake, Object.keys(FITMENT).sort(), "Select make");

    fitMake.addEventListener("change", function () {
      populateModels(fitMake.value);
    });

    if (fitModel) {
      fitModel.addEventListener("change", function () {
        populateYears(fitMake.value, fitModel.value);
      });
    }

    if (fitYear) {
      fitYear.addEventListener("change", function () {
        if (fitMake.value && fitModel.value && fitYear.value) {
          showFit(fitMake.value, fitModel.value, fitYear.value);
        }
      });
    }
  }

  if (fitForm) {
    fitForm.addEventListener("submit", function (event) {
      event.preventDefault();
      if (!fitMake || !fitModel || !fitYear) return;

      if (!fitMake.value) {
        fitMake.focus();
        return;
      }
      if (!fitModel.value) {
        fitModel.focus();
        return;
      }
      if (!fitYear.value) {
        fitYear.focus();
        return;
      }

      showFit(fitMake.value, fitModel.value, fitYear.value);

      if (fitResult && window.innerWidth < 960) {
        fitResult.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "nearest" });
      }
    });
  }

  var fitReset = $("[data-fit-reset]");
  if (fitReset) {
    fitReset.addEventListener("click", function () {
      if (fitMake) fitMake.value = "";
      if (fitModel) {
        fillSelect(fitModel, [], "Select model");
        fitModel.disabled = true;
      }
      if (fitYear) {
        fillSelect(fitYear, [], "Select year");
        fitYear.disabled = true;
      }
      resetFitResult();
      if (fitMake) fitMake.focus();
    });
  }

  /* ------------------------------------------------------------------------
     Installation tabs
     ------------------------------------------------------------------------ */

  var tabs = $$("[data-tab]");
  var panels = $$("[data-panel]");
  var hotspots = $$("[data-tab-target]");
  var schematic = $("[data-schematic]");

  function activateTab(name, focusTab) {
    tabs.forEach(function (tab) {
      var active = tab.getAttribute("data-tab") === name;
      tab.setAttribute("aria-selected", active ? "true" : "false");
      tab.setAttribute("tabindex", active ? "0" : "-1");
      if (active && focusTab) tab.focus();
    });

    panels.forEach(function (panel) {
      panel.hidden = panel.getAttribute("data-panel") !== name;
    });

    hotspots.forEach(function (hotspot) {
      hotspot.classList.toggle("is-active", hotspot.getAttribute("data-tab-target") === name);
    });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      activateTab(tab.getAttribute("data-tab"), false);
    });

    tab.addEventListener("keydown", function (event) {
      var currentIndex = tabs.indexOf(tab);
      var nextIndex = null;

      if (event.key === "ArrowRight") nextIndex = (currentIndex + 1) % tabs.length;
      if (event.key === "ArrowLeft") nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      if (event.key === "Home") nextIndex = 0;
      if (event.key === "End") nextIndex = tabs.length - 1;

      if (nextIndex === null) return;
      event.preventDefault();
      activateTab(tabs[nextIndex].getAttribute("data-tab"), true);
    });
  });

  hotspots.forEach(function (hotspot) {
    hotspot.addEventListener("click", function () {
      activateTab(hotspot.getAttribute("data-tab-target"), false);
    });
  });

  var routeToggle = $("[data-route-toggle]");
  if (routeToggle && schematic) {
    routeToggle.addEventListener("change", function () {
      schematic.classList.toggle("is-route-off", !routeToggle.checked);
    });
  }

  /* ------------------------------------------------------------------------
     Cart
     ------------------------------------------------------------------------ */

  var cartDialog = $("#bf-cart");
  var cartList = $("[data-cart-list]");
  var cartEmpty = $("[data-cart-empty]");
  var cartFoot = $("[data-cart-foot]");
  var cartTotalEl = $("[data-cart-total]");
  var cartTitleCount = $("[data-cart-title-count]");
  var shipLabel = $("[data-ship-label]");
  var shipFill = $("[data-ship-fill]");
  var checkoutBtn = $("[data-checkout]");
  var localCartKey = "mangoal-bf26-cart";
  var localItems = readStore(localCartKey, []);
  var shopifyCart = null;
  var lastFocused = null;

  if (!Array.isArray(localItems)) localItems = [];
  localItems = localItems
    .filter(function (item) {
      return item && productByKey[item.key] && Number(item.qty) > 0;
    })
    .map(function (item) {
      return { key: item.key, qty: Math.floor(Number(item.qty)) };
    });

  function currentItems() {
    if (isShopify) {
      if (!shopifyCart || !Array.isArray(shopifyCart.items)) return [];
      return shopifyCart.items.map(function (item) {
        return {
          key: item.key,
          name: item.product_title,
          variant: item.variant_title || "",
          qty: item.quantity,
          price: (item.final_price || item.price) / 100,
          image: item.image || null,
        };
      });
    }

    return localItems.map(function (item) {
      var product = productByKey[item.key];
      return {
        key: item.key,
        name: product.name,
        variant: product.variant || "",
        qty: item.qty,
        price: product.price,
        image: product.image || null,
      };
    });
  }

  function cartCount() {
    if (isShopify) return shopifyCart ? shopifyCart.item_count : 0;
    return localItems.reduce(function (total, item) {
      return total + item.qty;
    }, 0);
  }

  function cartSubtotal() {
    if (isShopify) return shopifyCart ? shopifyCart.total_price / 100 : 0;
    return localItems.reduce(function (total, item) {
      var product = productByKey[item.key];
      return total + (product ? product.price * item.qty : 0);
    }, 0);
  }

  function cartItemMarkup(item) {
    var image = safeImageUrl(item.image);
    var media = image
      ? '<img src="' + image + '" alt="" width="66" height="76" loading="lazy">'
      : '<svg aria-hidden="true"><use href="#bf-i-camera"></use></svg>';

    return (
      '<article class="bf-cart__item" data-cart-key="' + escapeHtml(item.key) + '">' +
        '<div class="bf-cart__media">' + media + "</div>" +
        '<div class="bf-cart__info">' +
          '<p class="bf-cart__name">' + escapeHtml(item.name) + "</p>" +
          '<p class="bf-cart__variant">' + escapeHtml(item.variant) + "</p>" +
          '<div class="bf-cart__row">' +
            '<div class="bf-qty">' +
              '<button type="button" data-cart-dec aria-label="Decrease quantity"><svg aria-hidden="true"><use href="#bf-i-minus"></use></svg></button>' +
              "<span>" + item.qty + "</span>" +
              '<button type="button" data-cart-inc aria-label="Increase quantity"><svg aria-hidden="true"><use href="#bf-i-plus"></use></svg></button>' +
            "</div>" +
            '<span class="bf-cart__price">' + money(item.price * item.qty) + "</span>" +
          "</div>" +
          '<button class="bf-cart__remove" type="button" data-cart-remove>Remove</button>' +
        "</div>" +
      "</article>"
    );
  }

  function renderCart() {
    var count = cartCount();
    var total = cartSubtotal();
    var items = currentItems();

    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = String(count);
    });

    $$("[data-open-cart]").forEach(function (el) {
      el.setAttribute("aria-label", "Open bag, " + count + (count === 1 ? " item" : " items"));
      el.classList.toggle("has-items", count > 0);
    });

    if (cartTitleCount) cartTitleCount.textContent = "(" + count + ")";

    if (cartList) {
      cartList.innerHTML = items.map(cartItemMarkup).join("");

      if (memberState && items.length) {
        cartList.insertAdjacentHTML(
          "beforeend",
          '<div class="bf-cart__bonus">' +
            '<svg aria-hidden="true"><use href="#bf-i-tool"></use></svg>' +
            "<div><strong>Member bonus · Free parking harness</strong>" +
            "<span>Added automatically when your member window opens. Worth $49.</span></div>" +
          "</div>"
        );
      }
    }

    if (cartEmpty) cartEmpty.hidden = items.length > 0;
    if (cartList) cartList.hidden = items.length === 0;
    if (cartFoot) cartFoot.hidden = items.length === 0;
    if (cartTotalEl) cartTotalEl.textContent = money(total);

    if (shipLabel && shipFill) {
      var remaining = Math.max(0, freeShippingThreshold - total);
      if (!items.length) {
        shipLabel.textContent = "Free express shipping on orders over $" + freeShippingThreshold + ".";
        shipFill.style.width = "0%";
      } else if (remaining > 0) {
        shipLabel.innerHTML = "Add <strong>" + money(remaining) + "</strong> for free express shipping.";
        shipFill.style.width = Math.min(100, (total / freeShippingThreshold) * 100) + "%";
      } else {
        shipLabel.innerHTML = "<strong>Free express shipping unlocked.</strong>";
        shipFill.style.width = "100%";
      }
    }
  }

  function openCart() {
    if (!cartDialog || cartDialog.open) return;
    lastFocused = document.activeElement;
    renderCart();
    cartDialog.classList.remove("is-closing");
    if (typeof cartDialog.showModal === "function") {
      cartDialog.showModal();
    } else {
      cartDialog.setAttribute("open", "");
    }
    document.body.classList.add("bf-lock");
    $$("[data-open-cart]").forEach(function (button) {
      button.setAttribute("aria-expanded", "true");
    });
    var close = $("[data-close-cart]", cartDialog);
    if (close) window.setTimeout(function () { close.focus(); }, 30);
  }

  function closeCart() {
    if (!cartDialog || !cartDialog.open || cartDialog.classList.contains("is-closing")) return;
    cartDialog.classList.add("is-closing");
    window.setTimeout(function () {
      if (typeof cartDialog.close === "function") cartDialog.close();
      else cartDialog.removeAttribute("open");
      cartDialog.classList.remove("is-closing");
      document.body.classList.remove("bf-lock");
      $$("[data-open-cart]").forEach(function (button) {
        button.setAttribute("aria-expanded", "false");
      });
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }, 230);
  }

  function addLocalItem(key, qty) {
    var product = productByKey[key];
    if (!product) return;
    var existing = localItems.find(function (item) {
      return item.key === key;
    });
    if (existing) existing.qty += qty;
    else localItems.push({ key: key, qty: qty });
    writeStore(localCartKey, localItems);
  }

  function addToCart(key, qty) {
    var product = productByKey[key];
    if (!product) return;
    if (product.available === false) {
      showToast("That kit is sold out. Join the list for the next drop.");
      return;
    }

    if (isShopify) {
      if (!product.variantId) {
        showToast("This kit is not available right now.");
        return;
      }
      fetch(window.BF26_SHOPIFY.addUrl || "/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: product.variantId, quantity: qty }] }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error("add failed");
          return refreshShopifyCart();
        })
        .then(function () {
          renderCart();
          openCart();
        })
        .catch(function () {
          showToast("We couldn't add that kit. Try again.");
        });
      return;
    }

    addLocalItem(key, qty);
    renderCart();
    openCart();
  }

  function changeCartQuantity(key, quantity) {
    if (isShopify) {
      fetch(window.BF26_SHOPIFY.changeUrl || "/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error("change failed");
          return refreshShopifyCart();
        })
        .then(renderCart)
        .catch(function () {
          showToast("We couldn't update your bag. Try again.");
        });
      return;
    }

    var item = localItems.find(function (entry) {
      return entry.key === key;
    });
    if (!item) return;
    item.qty = quantity;
    if (item.qty <= 0) {
      localItems = localItems.filter(function (entry) {
        return entry.key !== key;
      });
    }
    writeStore(localCartKey, localItems);
    renderCart();
  }

  function refreshShopifyCart() {
    return fetch(window.BF26_SHOPIFY.cartUrl || "/cart.js", {
      headers: { Accept: "application/json" },
    })
      .then(function (response) {
        if (!response.ok) throw new Error("cart fetch failed");
        return response.json();
      })
      .then(function (cart) {
        shopifyCart = cart;
        return cart;
      });
  }

  document.addEventListener("click", function (event) {
    var addButton = event.target.closest("[data-add-key]");
    if (addButton) {
      event.preventDefault();
      addToCart(addButton.getAttribute("data-add-key"), 1);
      return;
    }

    var inc = event.target.closest("[data-cart-inc]");
    var dec = event.target.closest("[data-cart-dec]");
    var remove = event.target.closest("[data-cart-remove]");

    if (inc || dec || remove) {
      var row = event.target.closest("[data-cart-key]");
      if (!row) return;
      var key = row.getAttribute("data-cart-key");
      var current = currentItems().find(function (item) {
        return item.key === key;
      });
      if (!current) return;
      event.preventDefault();
      if (inc) changeCartQuantity(key, current.qty + 1);
      else if (dec) changeCartQuantity(key, current.qty - 1);
      else changeCartQuantity(key, 0);
      return;
    }

    var open = event.target.closest("[data-open-cart]");
    if (open) {
      event.preventDefault();
      openCart();
    }
  });

  if (cartDialog) {
    $$("[data-close-cart]", cartDialog).forEach(function (button) {
      button.addEventListener("click", closeCart);
    });

    var closeCartLink = $("[data-close-cart-link]", cartDialog);
    if (closeCartLink) {
      closeCartLink.addEventListener("click", function (event) {
        event.preventDefault();
        if (cartDialog.open) cartDialog.close();
        document.body.classList.remove("bf-lock");
        $$("[data-open-cart]").forEach(function (button) {
          button.setAttribute("aria-expanded", "false");
        });
        var dropTarget = document.querySelector("#drop");
        if (dropTarget) {
          dropTarget.scrollIntoView({
            behavior: reduceMotion ? "auto" : "smooth",
            block: "start",
          });
        }
      });
    }

    cartDialog.addEventListener("click", function (event) {
      if (event.target === cartDialog) closeCart();
    });

    cartDialog.addEventListener("cancel", function (event) {
      event.preventDefault();
      closeCart();
    });

    cartDialog.addEventListener("close", function () {
      document.body.classList.remove("bf-lock");
    });
  }

  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function () {
      if (!currentItems().length) return;
      if (isShopify) {
        window.location.href = window.BF26_SHOPIFY.checkoutUrl || "/checkout";
        return;
      }
      showToast("Prototype checkout. The Shopify build opens checkout here.");
    });
  }

  cartReady = true;

  if (isShopify) {
    refreshShopifyCart().then(renderCart).catch(renderCart);
  } else {
    renderCart();
  }

  /* ------------------------------------------------------------------------
     Menu
     ------------------------------------------------------------------------ */

  var menuDialog = $("#bf-menu");
  var menuLastFocused = null;

  function openMenu() {
    if (!menuDialog || menuDialog.open) return;
    menuLastFocused = document.activeElement;
    menuDialog.classList.remove("is-closing");
    if (typeof menuDialog.showModal === "function") menuDialog.showModal();
    else menuDialog.setAttribute("open", "");
    document.body.classList.add("bf-lock");
    var trigger = $("[data-open-menu]");
    if (trigger) trigger.setAttribute("aria-expanded", "true");
    var close = $("[data-close-menu]", menuDialog);
    if (close) window.setTimeout(function () { close.focus(); }, 30);
  }

  function closeMenu() {
    if (!menuDialog || !menuDialog.open || menuDialog.classList.contains("is-closing")) return;
    if (typeof menuDialog.close === "function") menuDialog.close();
    else menuDialog.removeAttribute("open");
    document.body.classList.remove("bf-lock");
    var trigger = $("[data-open-menu]");
    if (trigger) trigger.setAttribute("aria-expanded", "false");
    if (menuLastFocused && menuLastFocused.focus) menuLastFocused.focus();
  }

  var openMenuBtn = $("[data-open-menu]");
  if (openMenuBtn) openMenuBtn.addEventListener("click", openMenu);

  if (menuDialog) {
    $$("[data-close-menu]", menuDialog).forEach(function (button) {
      button.addEventListener("click", closeMenu);
    });

    $$("[data-menu-link]", menuDialog).forEach(function (link) {
      link.addEventListener("click", closeMenu);
    });

    menuDialog.addEventListener("click", function (event) {
      if (event.target === menuDialog) closeMenu();
    });

    menuDialog.addEventListener("cancel", function (event) {
      event.preventDefault();
      closeMenu();
    });

    menuDialog.addEventListener("close", function () {
      document.body.classList.remove("bf-lock");
    });
  }

  /* ------------------------------------------------------------------------
     Keyboard niceties
     ------------------------------------------------------------------------ */

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    if (cartDialog && cartDialog.open) closeCart();
    if (menuDialog && menuDialog.open) closeMenu();
  });

  window.BF26_BOOTED = true;
})();
